import { Injectable } from '@angular/core';
import { ITourOptions, ITourStepPosition, TourGuideService } from '../../core/tour-guide.service';
import { MainRoutes } from '../../core/enums';
import { NavigationService } from '../../core/navigation.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AiInsightsTourService {

  constructor(private tourGuide: TourGuideService,
              private navigation: NavigationService) {
  }

  /**
   * Set up AI Insights Tour
   */
  setUpAiInsightsTour(notifier: Observable<any>) {
    this.tourGuide.addStepsAndStartTour([
      {
        attachTo: {
          element: '#ai_insights-nav-button',
          on: ITourStepPosition.RIGHT_START,
        },
        titleTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.AI_INSIGHTS.STEP1.TITLE',
        textTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.AI_INSIGHTS.STEP1.TEXT',
        highlightClass: 'campaign-nav-button',
        buttons: [
          {
            classes: 'cancel-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.CANCEL',
            type: 'cancel',
          },
          {
            classes: 'next-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.NEXT',
            action: () => this.navigation.navigate([MainRoutes.AI_INSIGHTS]).then(() =>
                setTimeout(() => this.tourGuide.delegator.next(), 250)), // leave some time to render the view
          }],
        when: {
          show: () => {
            this.tourGuide.progressOnShow();
          },
        },
      },
      {
        attachTo: {
          element: '#ai_insights_prompt_input',
          on: ITourStepPosition.TOP_START,
        },
        titleTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.AI_INSIGHTS.STEP2.TITLE',
        textTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.AI_INSIGHTS.STEP2.TEXT',
        highlightClass: 'grey-outline-16',
        buttons: [
          {
            classes: 'back-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.BACK',
            type: 'back',
          },
          {
            classes: 'next-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.NEXT',
            type: 'next',
          }],
        when: {
          show: () => {
            this.tourGuide.progressOnShow();
          },
        },
      },
      {
        attachTo: {
          element: '#ai_insights_prompt_builder_lg',
          on: ITourStepPosition.BOTTOM_START,
        },
        titleTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.AI_INSIGHTS.STEP3.TITLE',
        textTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.AI_INSIGHTS.STEP3.TEXT',
        highlightClass: 'grey-outline-16',
        buttons: [
          {
            classes: 'back-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.BACK',
            type: 'back',
          },
          {
            classes: 'next-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.NEXT',
            type: 'next',
          }],
        when: {
          show: () => {
            this.tourGuide.progressOnShow();
          },
        },
      },
      {
        attachTo: {
          element: '#ai_insights_chat_history',
          on: ITourStepPosition.RIGHT_START,
        },
        titleTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.AI_INSIGHTS.STEP4.TITLE',
        textTranslationKey: 'TOUR_GUIDE.CAMPAIGNS.AI_INSIGHTS.STEP4.TEXT',
        highlightClass: 'filter-menu',
        buttons: [
          {
            classes: 'back-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.BACK',
            type: 'back',
          },
          {
            classes: 'next-button',
            textTranslationKey: 'TOUR_GUIDE.BUTTONS.FINISH',
            type: 'next',
          }],
        when: {
          show: () => {
            this.tourGuide.progressOnShow();
          },
        },
      },
    ], new ITourOptions('AI_INSIGHTS_TOUR',
        false,
        false,
        this.tourGuide.deferUntil(notifier)));
  }
}


